import { Cookies } from 'react-cookie';

// Set by appquickchat/payments/discord_credits.py; the value is only the scenario id the caller asked for.
export const DISCORD_CREDITS_UNAVAILABLE_COOKIE = 'qc_discord_credits_unavailable';

// Django's `slug` alphabet: any .quickchat.ai subdomain can write this cookie, so the value is untrusted.
const SCENARIO_ID_PATTERN = /^[-a-zA-Z0-9_]+$/;

export type DiscordCreditsNotice = {
  returnPath: string | null;
};

export const readDiscordCreditsNotice = (): DiscordCreditsNotice | null => {
  const raw: unknown = new Cookies().get(DISCORD_CREDITS_UNAVAILABLE_COOKIE, {
    doNotParse: true,
  });
  if (typeof raw !== 'string' || raw === '') return null;
  return { returnPath: SCENARIO_ID_PATTERN.test(raw) ? `/discord/credits/${raw}` : null };
};

export const clearDiscordCreditsNotice = (): void => {
  new Cookies().remove(DISCORD_CREDITS_UNAVAILABLE_COOKIE, { path: '/' });
};
